import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

export default [
  {
    imgSrc:
      'https://s3.amazonaws.com/cdns3.nerdwallet.com/img/landing/2021/21Q4_Home-Value/21Q4_home-value-lp_zig-zag-1.png',
    imgAlt: 'Thumbs up with dollar sign',
    title: 'Check Your Home Value for Free',
    description:
      'Find out how much your home is worth. See a breakdown of your home value over time and review your home equity.',
    link: '/mortgages/home-value',
  },
  {
    title: 'Do Home Improvements Add Value?',
    imgSrc: iconUri('Cash_back_3'),
    imgAlt: 'Cash Back',
    description:
      'Some home improvements projects are more likely to add value than others. Read our take on the best projects.',
    link: '/blog/mortgages/best-home-improvements-add-value/',
  },
  {
    imgSrc: iconUri('Certificate'),
    imgAlt: 'Documents',
    title: 'Should You DIY or Hire a Pro?',
    description:
      'While there’s something rewarding about tackling a job yourself, some projects are better left to experts.',
    link: '/blog/mortgages/home-improvement-diy-or-hire-a-pro/',
  },
  {
    imgSrc: iconUri('Approval'),
    imgAlt: 'Thumbs up with dollar sign',
    title: 'Determining Your Renovation Budget',
    description:
      'Determining a realistic budget can be one of the most daunting aspects of embarking on a home renovation project.',
    link: '/blog/finance/home-renovation-trends-guide-budget/',
  },
];
